import type { SatuanPendidikanDocumentTypes } from 'types/kinerja-pelaksanaan'

export const SATUAN_PENDIDIKAN_DOCUMENTS: Array<{
  type: SatuanPendidikanDocumentTypes
  label: string
}> = [
  {
    type: 'RPP',
    label: 'Rencana Pelaksanaan Pembelajaran (RPP)/Modul Ajar atau sejenisnya',
  },
  {
    type: 'PLANNING',
    label: 'Dokumen Perencanaan Satuan Pendidikan atau sejenisnya',
  },
  {
    type: 'REPORT',
    label: 'Dokumen Laporan Satuan Pendidikan atau sejenisnya',
  },
  { type: 'ATTENDANCE', label: 'Rangkuman Kehadiran Guru' },
  { type: 'ASSIGNMENT', label: 'Surat Penugasan' },
]
